import ShippingSimulatorProvider from './hooks/useShippingSimulator';

import { ShippingSimulatorProps } from './@types/ShippingSimulatorProps';
import ShippingContainer from './handles/ShippingContainer';
import AdressForm from './handles/AdressForm';
import Input from './handles/Input';
import ForgottenURL from './handles/ForgottenURL';
import Button from './handles/Button';
import ShippingResultContainer from './handles/ShippingResultContainer';

const ShippingSimulator = (props: ShippingSimulatorProps) => (
	<ShippingSimulatorProvider {...props}>
		<ShippingContainer>
			<AdressForm>
				<Input></Input>
				<ForgottenURL></ForgottenURL>
			</AdressForm>
			<Button></Button>
		</ShippingContainer>
		<ShippingResultContainer />
	</ShippingSimulatorProvider>
);

export default ShippingSimulator;
